import { Navigate, useLocation } from "react-router-dom";
import usePageTitle from "@/hooks/usePageTitle";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import MobileUniversityLandingPage from "./MobileUniversityLandingPage";

export default function UniversityIndexPage() {
  usePageTitle("/education/universities/:universityId", "Education | University Details");
  const location = useLocation();
  const { isCompactLayout } = useIsCompactLayout();

  if (isCompactLayout) {
    return <MobileUniversityLandingPage />;
  }

  return <Navigate to={`${location.pathname}/students`} replace />;
}
